import { Box, Button, Grid, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import GravityBox from '../Components/GravityBoxes';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, EastOutlined, WestOutlined } from '@mui/icons-material';
import LetsTalk from '../Components/LetsTalk';
import AOS from "aos";
import "aos/dist/aos.css";
import { useAppContext } from '../context/useAppContext';


function Clients() {

    const navigate = useNavigate();
    const [page, setPage] = useState(1);
    const itemsPerPage = 7;
    const { darkTheme } = useAppContext();

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    }, [page])



    useEffect(() => {
        AOS.init({
            duration: 1000, // animation duration
            once: true,     // animation happens only once
        });
    }, []);

    const clients = [
        {
            type: "MYSTERY SHOPPING PLATFORM", title: "Mystery Management – All-in-One Mystery Shopping Platform", tags: ["#mysteryshop", "#cxinsights", "#service", "#smartanalytics", "#experience", "#metrics"], img: "mysterymanagement"
        },
        { type: "TELECOM SELF CARE APP", title: "Belong – Digital Connectivity Mobile App", tags: ["#telco", "#connect", "#mobile", "#data", "#ux", "#network"], img: "belong" },
        {
            type: "SPORTS MANAGEMENT PLATFORM", title: "WeFroth – All-in-One Sports Management Platform", tags: ["#sports", "#live", "#teams", "#analytics", "#scores", "#match"], img: "wefroth"
        },
        {
            type: "STOCK/CRYPTO TRADING PLATFORM", title: "Wolfpack – Advanced Investment and Trading Platform", tags: ["#trading", "#fintech", "#crypto", "#aiinvest", "#wealth", "#market"], img: "wolfpack"
        },
        { type: "E-COMMERCE PLATFORM", title: "The Juice Lab – Daily Wellness Shot E-Commerce Platform", tags: ["#ecom", "#shopify", "#orders", "#delivery", "#wellness", "#logistics"], img: "juicelabs" },
        {
            type: "SPORTS MANAGEMENT PLATFORM", title: "FutsalOz – Elite Futsal Management Web Platform",
            tags: ["#futsal", "#sports", "#booking", "#teams", "#league", "#stadium"], img: "futsaloz"
        },

        { type: "INSTALLATION AND WARRANTY MANAGEMENT PLATFORM", title: "Redarc Electronics – Installation Management Portal", tags: ["#installation", "#asset", "#warranty", "#service", "#replacement", "#jobs"], img: "redarc" },

        { type: "SPORTS BETTING PLATFORM", title: "Bet Odyssey – Australia's First Crowd Tipping Platform", tags: ["#bet", "#sports", "#racing", "#analytics", "#crowd", "#tips"], img: "betodyssey" },
        { type: "HIRING PLATFORM", title: "SkillJobs – Complete Recruitment & Hiring Platform", tags: ["#jobs", "#hiring", "#employment", "#hr", "#skills", "#recruit"], img: "skilljobs" },
        { type: "SOCIAL FITNESS PLATFORM", title: "Tandm – Workplace Social Fitness & Personality Platform", tags: ["#fitness", "#wellness", "#growth", "#social", "#insight", "#excercise"], img: "tandm" },
        { type: "PHOTO/VIDEO CAPTURE AND SHARING PLATFORM", title: "Pinch – Effortless Group Photo Sharing Platform", tags: ["#photo", "#social", "#share", "#memory", "#gallery", "#app"], img: "pinch" },
        { type: "E-MAGAZINE PLATFORM", title: "Spooled – Digital Magazine Creation & Publishing Platform", tags: ["#publish", "#media", "#magazine", "#read", "#content", "#app"], img: "spooled" },
        { type: "NETWORK INTELLIGENCE PLATFORM", title: "Sinefa – Digital Experience & Network Intelligence Platform", tags: ["#network", "#monitor", "#performance", "#root", "#jobs", "#observe"], img: "sinefa" },
        // { type: "TRADING PLATFORM", title: "Wolfpack Web Platform & Mobile Application", tags: ["#technoloy", "#stockinvestment", "#trading", "#crypto", "#analysis"], img: "connexion" },
        { type: "MEDIA STREAMING PLATFORM", title: "Miroamer – Global Internet Radio Streaming Platform", tags: ["#radio", "#audio", "#music", "#stream", "#global", "#media"], img: "miroamer" },
        { type: "SOCIAL DISCOVERY AND DATING APP", title: "LOUCA – Smart Social & Dating Experience App", tags: ["#dating", "#ai", "#social", "#match", "#vibe", "#connect"], img: "louca" },
        { type: "LIFESTYLE", title: "Zigzek – Emotional Wellness App", tags: ["#Emotional Wellness", "#Life Coaching", "#Expert Advice", "#Personal Growth", "#Self Care"], img: "zigzek" },
    ]

    const containerHeight = 200;
    const tagHeight = 30;

    const BOXES = [
        { id: 1, color: darkTheme ? "rgba(71, 170, 167)" : "rgb(0, 54, 61)", label: "#technoloy" },
        { id: 2, color: darkTheme ? "rgba(71, 170, 167)" : "rgb(0, 54, 61)", label: "#stockinvestment" },
        { id: 3, color: darkTheme ? "rgba(71, 170, 167)" : "rgb(0, 54, 61)", label: "#trading" },
        { id: 4, color: darkTheme ? "rgba(71, 170, 167)" : "rgb(0, 54, 61)", label: "#crypto" },
        { id: 5, color: darkTheme ? "rgba(71, 170, 167)" : "rgb(0, 54, 61)", label: "#analysis" },
    ];

    const startIndex = (page - 1) * itemsPerPage;
    const selectedClients = clients.slice(startIndex, startIndex + itemsPerPage);
    return (
        <Box mt={{ xs: 8, md: 4, lg: 5 }}>
            <Typography
                component="h1"
                variant="h1"
                sx={{
                    position: 'absolute',
                    width: 1,
                    height: 1,
                    padding: 0,
                    margin: -1,
                    overflow: 'hidden',
                    clip: 'rect(0, 0, 0, 0)',
                    whiteSpace: 'nowrap',
                    border: 0
                }}
            >
                CHECKOUT OUR PRECIOUS CLIENTS
            </Typography>
            <Typography data-aos="fade-up" gutterBottom className='fs-64 text-center bold-text'><span className='text-color-main'>CHECKOUT OUR</span> <br /> <span className='text-light-main'>  PRECIOUS CLIENTS</span></Typography>
            {selectedClients?.map((item, index) => (

                <Grid onClick={() => {
                    navigate(`/client-details/${item?.img}`);
                }} key={index} container className='bg-light-main mb-2 p-3 pb-1' spacing={2} alignItems={'stretch'}>
                    <Grid size={{ xs: 12, md: 6, lg: 8, xl: 9 }} className='d-flex flex-column'>
                        <Typography data-aos="fade-up" gutterBottom className='fs-14  fw-bold text-light-main'>{item?.type}</Typography>
                        <Typography data-aos="fade-up" gutterBottom width={{ xs: "100%", md: "50%" }} onClick={() => {
                            navigate(`/client-details/${item?.img}`);
                        }} sx={{ cursor: "pointer" }} className="text-color-main fs-42">{item?.title}</Typography>
                        <Box onClick={(e) => e.stopPropagation()} maxWidth={'500px'} flex={1} position={'relative'} overflow={'hidden'}>
                            <GravityBox BOXES={item.tags} />
                        </Box>
                    </Grid>
                    <Grid className='border-10 bg-white' data-aos="zoom-in" component='img' src={`/Images/Clients/${item?.img}.png`} height={{ xs: "420px", xl: '330px' }} sx={{ objectFit: item?.img === 'zigzek' ? "contain" : 'cover' }} size={{ xs: 12, md: 6, lg: 4, xl: 3 }}></Grid>
                </Grid>
            ))}
            <Box display="flex" justifyContent="center" gap={2} mt={3}>

                <Button
                    variant="contained"
                    className={`${page === 1 ? "bg-main text-grey" : "bg-primary-main text-white"}  py-2 px-4`}
                    sx={{ borderRadius: '20px', borderTopLeftRadius: "50px", borderBottomLeftRadius: "50px" }}
                    disabled={page === 1}
                    onClick={() => setPage(prev => prev - 1)}
                >
                    <WestOutlined /> &nbsp;Previous
                </Button>
                <Button
                    variant="contained"
                    className={`${(startIndex + itemsPerPage >= clients.length) ? "bg-main text-grey" : "bg-primary-main text-white"} py-2 px-4`}
                    sx={{ borderRadius: '20px', borderTopRightRadius: "50px", borderBottomRightRadius: "50px" }}
                    disabled={startIndex + itemsPerPage >= clients.length}
                    onClick={() => setPage(prev => prev + 1)}
                >
                    Next &nbsp; <EastOutlined />
                </Button>

            </Box>
            <Box className='mt-5'>
                <LetsTalk />
            </Box>
        </Box>
    )
}

export default Clients
